import { render, staticRenderFns } from "./psychologyTeacher.vue?vue&type=template&id=1a64d018&"
import script from "./psychologyTeacher.vue?vue&type=script&lang=js&"
export * from "./psychologyTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports